<template>
  <transition name="fade">
    <div class="notification is-print-hide" v-if="notification">
      <div class="close" @click="closenotification"><img :src="require('@/assets/img/modal_close.png')" alt="" /></div>
      <div class="notification_box">
        <div class="header">你有新的处方需要处理</div>
        <div class="hand" @click="gohand">
          立即操作
          <img src="" alt="" />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import Constant from '@/lib/constant';
import { hasPermission } from '@/util/index';
import AudioPlayer from '@/util/audio';
const baseRole = Constant.RoleList;
const startTime = 4102444800000; // 跟后端约定默认传个超大的时间戳

const audioPlayer = new AudioPlayer({
  src: require('@/assets/audio/prescription-remind.mp3'),
  loopCount: 1
});

export default {
  data() {
    return {
      lastTs: null
    };
  },
  computed: {
    notification() {
      return this.$store.getters.notification;
    }
  },
  mounted() {
    this.init(); // 执行初始化代码
  },
  methods: {
    gohand() {
      this.closenotification();
      this.$router.push({ path: `/waitPrescriptionListMid` });
    },
    closenotification() {
      this.$store.dispatch('global/SETnotification', false);
    },
    init() {
      // 初始化通知
      const per = [baseRole.b, baseRole.f];
      if (hasPermission(per)) {
        this.getMessage();
      }
    },
    async getMessage() {
      // 轮询查看是否有处方信息
      window.notificationTimer = setTimeout(() => {
        this.getMessage();
      }, 20000);
      const lastTs = this.lastTs;
      let prams = {
        ts: Date.now(),
        type: 'pharmacist'
      };
      if (lastTs) {
        prams.ts = lastTs;
      } else {
        prams.ts = startTime;
      }
      let res = await Fetch.have_messages({ ...prams });
      this.lastTs = res.ts; // 上一次消息的时间戳
      if (res.hasUnRead === true) {
        audioPlayer.play();
        this.$store.dispatch('global/SETnotification', true);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.notification {
  position: absolute;
  z-index: 10;
  bottom: 48px;
  right: 0;
  .close {
    right: 14px;
    top: 10px;
    cursor: pointer;
    position: absolute;
  }
  .notification_box {
    padding: 16px;
    padding-right: 36px;
    background: #fff;
    .header {
      color: #707070;
      font-size: 14px;
      padding-bottom: 10px;
    }
    .hand {
      font-size: 14px;
      color: #ebb436;
      cursor: pointer;
    }
  }
}
</style>
